module.exports = {
  "data": {
    "hotelSpec": {
      "name": "The WB Abu Dhabi, Curio Collection by Hilton",
      "address": {
        "addressLines": [
          "Yas Island"
        ],
        "locality": "Abu Dhabi",
        "continentCode": "AS",
        "regionCode": "AE",
        "timezone": "Asia/Dubai"
      },
      "coordinates": {
        "latitude": 24.489769,
        "longitude": 54.598516
      },
      "contactInfo": {
        "phone": [
          {
            "italianLeadingZero": false,
            "numberOfLeadingZeros": 0,
            "rawInput": "971-02 208 6889"
          }
        ],
        "fax": [],
        "email": []
      },
      "amenities": [
        {
          "hotelAmenityType": "LAUNDRY_VALET_SERVICE",
          "additionalInfo": "Dry cleaning/laundry service",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "GIFT_NEWS_STAND",
          "additionalInfo": "Gift shops or newsstand",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ADDITIONAL_SERVICES_AMENITIES_FACILITIES_ON_PROPERTY",
          "additionalInfo": "Outdoor entertainment area",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "UMBRELLAS",
          "additionalInfo": "Pool umbrellas",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "MEETING_ROOMS",
          "additionalInfo": "Number of meeting rooms - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CONFERENCE_FACILITIES",
          "additionalInfo": "Conference space size (meters) - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "COMPLIMENTARY_WIRELESS_INTERNET",
          "additionalInfo": "Free WiFi",
          "isComplimentary": true
        },
        {
          "hotelAmenityType": "LOUNGES_BARS",
          "additionalInfo": "Number of bars/lounges - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "POOLSIDE_SNACK_BAR",
          "additionalInfo": "Number of poolside bars - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "OUTDOOR_POOL",
          "additionalInfo": "Number of outdoor pools - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "WHEELCHAIR_ACCESS",
          "additionalInfo": "Wheelchair-accessible lounge",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ACCESSIBLE_FACILITIES",
          "additionalInfo": "Visual alarms in hallways",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "MULTILINGUAL_STAFF",
          "additionalInfo": "Multilingual staff",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BREAKFAST_SERVED_IN_RESTAURANT",
          "additionalInfo": "Breakfast available (surcharge)",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "COFFEE_SHOP",
          "additionalInfo": "Number of coffee shops/cafes - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CHILDREN_PROGRAMS",
          "additionalInfo": "Children's club (free)",
          "isComplimentary": true
        },
        {
          "hotelAmenityType": "ELEVATORS",
          "additionalInfo": "Elevator",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "SECURED_PARKING",
          "additionalInfo": "Secured parking",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BANQUET_FACILITIES",
          "additionalInfo": "Banquet hall",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BALLROOM",
          "additionalInfo": "Ballroom",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "SPA",
          "additionalInfo": "Spa treatment room(s)",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "HEALTH_CLUB",
          "additionalInfo": "Health club",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "FITNESS_CENTER",
          "additionalInfo": "24-hour fitness facilities",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "STORAGE_SPACE",
          "additionalInfo": "Luggage storage",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BELL_STAFF_PORTER",
          "additionalInfo": "Porter/bellhop",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CHILDRENS_PLAY_AREA",
          "additionalInfo": "Children's club",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "TWENTY_FOUR_HOUR_FRONT_DESK",
          "additionalInfo": "24-hour front desk",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "PLAYGROUND",
          "additionalInfo": "Playground on site",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "RESTAURANT",
          "additionalInfo": "Number of restaurants - ",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "LIMITED_SERVICE_HOUSEKEEPING",
          "additionalInfo": "Housekeeping on request",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "SMOKE_FREE_PROPERTY",
          "additionalInfo": "Smoke-free property",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "SAFE_DEPOSIT_BOX",
          "additionalInfo": "Safe-deposit box at front desk",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "POOL",
          "additionalInfo": "Children's pool",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "FREE_PARKING",
          "additionalInfo": "Free self parking",
          "isComplimentary": true
        },
        {
          "hotelAmenityType": "HAIRDRESSER_BARBER",
          "additionalInfo": "Hair salon",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ATM_CASH_MACHINE",
          "additionalInfo": "ATM/banking",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CONCIERGE_DESK",
          "additionalInfo": "Concierge services",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "PARKING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ROOM_SERVICE",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "COCKTAIL_LOUNGE",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "EXERCISE_GYM",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "GOLF",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "NON_SMOKING_ROOMS_GENERIC",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "DRY_CLEANING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CHILDREN_WELCOME",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "INTERNET_SERVICES",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "EXPRESS_CHECK_IN",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "VALET_PARKING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CURRENCY_EXCHANGE",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "MASSAGE_SERVICES",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "PHOTOCOPY_CENTER",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "FREE_HIGH_SPEED_INTERNET_CONNECTION",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ALL_PUBLIC_AREAS_NON_SMOKING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "AIR_CONDITIONING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "FREE_TRANSPORTATION",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "MEAL_PLAN_AVAILABLE",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "HOUSEKEEPING_DAILY",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ON_SITE_PARKING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BUFFET_BREAKFAST",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "ACCESSIBLE_PARKING",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "HEARING_IMPAIRED_SERVICES",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BEAUTY_SHOP_SALON",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BARBER_SHOP",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "STEAM_BATH",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "LOCKER_ROOM",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "TRANSPORTATION",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "LIVE_ENTERTAINMENT",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "TWENTY_FOUR_HOUR_SECURITY",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "SECURITY",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "MEDICAL_FACILITIES_SERVICE",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "BUSINESS_SERVICES",
          "additionalInfo": "",
          "isComplimentary": false
        },
        {
          "hotelAmenityType": "CARRYOUT_BREAKFAST",
          "additionalInfo": "",
          "isComplimentary": false
        }
      ],
      "descriptions": [
        {
          "type": "POLICIES",
          "value": "- Pool access available from 8:00 AM to 11:00 PM.\n- The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. \n- No pets and no service animals are allowed at this property. \n- Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. \n  \n- Extra-person charges may apply and vary depending on property policy\n- Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges\n- Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed\n- This property accepts credit cards, debit cards, and cash\n- This property reserves the right to pre-authorize the guest's credit card prior to arrival.\n- Cashless transactions are available\n- Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit\n- This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  \nThis property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
        },
        {
          "type": "DEPOSIT_POLICY",
          "value": "- Fee for buffet breakfast: approximately AED 120.00 for adults and AED 60 for children\n- Rollaway bed fee: AED 150.0 per night \nThe above list may not be comprehensive. Fees and deposits may not include tax and are subject to change. "
        },
        {
          "type": "GENERAL",
          "value": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
        },
        {
          "type": "ALERTS",
          "value": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
        }
      ],
      "imageSets": [
        {
          "category": "LOGO",
          "imageGroup": {
            "caption": "Primary image",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Reception",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Reception",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_z.jpg"
              }
            ]
          }
        },
        {
          "category": "LOBBY_VIEW",
          "imageGroup": {
            "caption": "Lobby sitting area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Private kitchen",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "Living area",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM",
          "imageGroup": {
            "caption": "View from room",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM_AMENITY",
          "imageGroup": {
            "caption": "Bathroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM_AMENITY",
          "imageGroup": {
            "caption": "Bathroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM_AMENITY",
          "imageGroup": {
            "caption": "Bathroom shower",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM_AMENITY",
          "imageGroup": {
            "caption": "Bathroom shower",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "GUEST_ROOM_AMENITY",
          "imageGroup": {
            "caption": "Bathroom shower",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Outdoor pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Outdoor pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Rooftop pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Rooftop pool",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "POOL_VIEW",
          "imageGroup": {
            "caption": "Swim-up bar",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RECREATIONAL_FACILITY",
          "imageGroup": {
            "caption": "Fitness facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RECREATIONAL_FACILITY",
          "imageGroup": {
            "caption": "Fitness facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RECREATIONAL_FACILITY",
          "imageGroup": {
            "caption": "Fitness studio",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_z.jpg"
              }
            ]
          }
        },
        {
          "category": "SPA",
          "imageGroup": {
            "caption": "Spa treatment",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Property amenity",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Property amenity",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Property amenity",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Property amenity",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Gift shop",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Gift shop",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's play area - indoor",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's activities",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's activities",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's activities",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's activities",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Children's activities",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Restaurant",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_z.jpg"
              }
            ]
          }
        },
        {
          "category": "RESTAURANT",
          "imageGroup": {
            "caption": "Breakfast buffet",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BAR_OR_LOUNGE",
          "imageGroup": {
            "caption": "Bar (on property)",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BAR_OR_LOUNGE",
          "imageGroup": {
            "caption": "Bar (on property)",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_z.jpg"
              }
            ]
          }
        },
        {
          "category": "PROPERTY_AMENITY",
          "imageGroup": {
            "caption": "Ballroom",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_z.jpg"
              }
            ]
          }
        },
        {
          "category": "BUSINESS_CENTER",
          "imageGroup": {
            "caption": "Meeting facility",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_z.jpg"
              }
            ]
          }
        },
        {
          "category": "EXTERIOR_VIEW",
          "imageGroup": {
            "caption": "Fountain",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_z.jpg"
              }
            ]
          }
        },
        {
          "category": "EXTERIOR_VIEW",
          "imageGroup": {
            "caption": "Exterior",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_z.jpg"
              }
            ]
          }
        },
        {
          "category": "EXTERIOR_VIEW",
          "imageGroup": {
            "caption": "Exterior",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_z.jpg"
              }
            ]
          }
        },
        {
          "category": "EXTERIOR_VIEW",
          "imageGroup": {
            "caption": "Exterior",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_z.jpg"
              }
            ]
          }
        },
        {
          "category": "EXTERIOR_VIEW",
          "imageGroup": {
            "caption": "Exterior",
            "images": [
              {
                "data": "",
                "dimensions": {
                  "height": 350,
                  "width": 350
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_b.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 70,
                  "width": 70
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_t.jpg"
              },
              {
                "data": "",
                "dimensions": {
                  "height": 800,
                  "width": 800
                },
                "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_z.jpg"
              }
            ]
          }
        }
      ],
      "hotelId": "SPOTNANA:1094885",
      "brandCode": "EH",
      "brandName": "Hilton Hotel Brands",
      "chainCode": "QQ",
      "chainName": "Curio Collection",
      "propertyTypes": [
        {
          "type": "RESORT",
          "description": ""
        },
        {
          "type": "HOTEL",
          "description": ""
        }
      ],
      "starRating": {
        "starRating": 5,
        "ratingType": "OFFICIAL"
      },
      "additionalAmenities": [],
      "checkinTime": {
        "iso8601": "15:00"
      },
      "checkoutTime": {
        "iso8601": "11:00"
      }
    },
    "rooms": [
      {
        "description": "Artist Double Room with Two Double Beds and Theme Park Access",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1190,
                  "currencyCode": "AED",
                  "convertedAmount": 323.99,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 279.65,
                  "currencyCode": "AED",
                  "convertedAmount": 76.14,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1190,
                    "currencyCode": "AED",
                    "convertedAmount": 323.99,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 279.65,
                    "currencyCode": "AED",
                    "convertedAmount": 76.14,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1190,
                  "currencyCode": "AED",
                  "convertedAmount": 323.99,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 279.65,
                  "currencyCode": "AED",
                  "convertedAmount": 76.14,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1190,
                      "currencyCode": "AED",
                      "convertedAmount": 323.99,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzFfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1270.75,
                  "currencyCode": "AED",
                  "convertedAmount": 345.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 298.63,
                  "currencyCode": "AED",
                  "convertedAmount": 81.3,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1270.75,
                    "currencyCode": "AED",
                    "convertedAmount": 345.97,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 298.63,
                    "currencyCode": "AED",
                    "convertedAmount": 81.3,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1270.75,
                  "currencyCode": "AED",
                  "convertedAmount": 345.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 298.63,
                  "currencyCode": "AED",
                  "convertedAmount": 81.3,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1270.75,
                      "currencyCode": "AED",
                      "convertedAmount": 345.97,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1296,
                  "currencyCode": "AED",
                  "convertedAmount": 352.85,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 304.56,
                  "currencyCode": "AED",
                  "convertedAmount": 82.92,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1296,
                    "currencyCode": "AED",
                    "convertedAmount": 352.85,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 304.56,
                    "currencyCode": "AED",
                    "convertedAmount": 82.92,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1296,
                  "currencyCode": "AED",
                  "convertedAmount": 352.85,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 304.56,
                  "currencyCode": "AED",
                  "convertedAmount": 82.92,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1296,
                      "currencyCode": "AED",
                      "convertedAmount": 352.85,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1351.5,
                  "currencyCode": "AED",
                  "convertedAmount": 367.96,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 317.6,
                  "currencyCode": "AED",
                  "convertedAmount": 86.47,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1351.5,
                    "currencyCode": "AED",
                    "convertedAmount": 367.96,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 317.6,
                    "currencyCode": "AED",
                    "convertedAmount": 86.47,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1351.5,
                  "currencyCode": "AED",
                  "convertedAmount": 367.96,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 317.6,
                  "currencyCode": "AED",
                  "convertedAmount": 86.47,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1351.5,
                      "currencyCode": "AED",
                      "convertedAmount": 367.96,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1472,
                  "currencyCode": "AED",
                  "convertedAmount": 400.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 345.92,
                  "currencyCode": "AED",
                  "convertedAmount": 94.18,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1472,
                    "currencyCode": "AED",
                    "convertedAmount": 400.77,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 345.92,
                    "currencyCode": "AED",
                    "convertedAmount": 94.18,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1472,
                  "currencyCode": "AED",
                  "convertedAmount": 400.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 345.92,
                  "currencyCode": "AED",
                  "convertedAmount": 94.18,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1472,
                      "currencyCode": "AED",
                      "convertedAmount": 400.77,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzNfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1572.5,
                  "currencyCode": "AED",
                  "convertedAmount": 428.13,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 369.54,
                  "currencyCode": "AED",
                  "convertedAmount": 100.61,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1572.5,
                    "currencyCode": "AED",
                    "convertedAmount": 428.13,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 369.54,
                    "currencyCode": "AED",
                    "convertedAmount": 100.61,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1572.5,
                  "currencyCode": "AED",
                  "convertedAmount": 428.13,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 369.54,
                  "currencyCode": "AED",
                  "convertedAmount": 100.61,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1572.5,
                      "currencyCode": "AED",
                      "convertedAmount": 428.13,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzNfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1814.75,
                  "currencyCode": "AED",
                  "convertedAmount": 494.08,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 426.47,
                  "currencyCode": "AED",
                  "convertedAmount": 116.11,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1814.75,
                    "currencyCode": "AED",
                    "convertedAmount": 494.08,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 426.47,
                    "currencyCode": "AED",
                    "convertedAmount": 116.11,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1814.75,
                  "currencyCode": "AED",
                  "convertedAmount": 494.08,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 426.47,
                  "currencyCode": "AED",
                  "convertedAmount": 116.11,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1814.75,
                      "currencyCode": "AED",
                      "convertedAmount": 494.08,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDFfMzM4MTMwMTk4XzNfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room features a flat-screen TV with cable channels, a tea and coffee maker, a seating area and heating. The unit has 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2008,
                  "currencyCode": "AED",
                  "convertedAmount": 546.7,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 471.88,
                  "currencyCode": "AED",
                  "convertedAmount": 128.47,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2008,
                    "currencyCode": "AED",
                    "convertedAmount": 546.7,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 471.88,
                    "currencyCode": "AED",
                    "convertedAmount": 128.47,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2008,
                  "currencyCode": "AED",
                  "convertedAmount": 546.7,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 471.88,
                  "currencyCode": "AED",
                  "convertedAmount": 128.47,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2008,
                      "currencyCode": "AED",
                      "convertedAmount": 546.7,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "Artist Double Room with Two Double Beds and Theme Park Access"
      },
      {
        "description": "Room, 2 Double Beds (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "FULL"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOVFFTQ1RRd09UTXdPRE0yTmhvRk16Y3pOalVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "2 Double Beds",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 323.99,
                  "currencyCode": "USD",
                  "convertedAmount": 323.99,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 76.14,
                  "currencyCode": "USD",
                  "convertedAmount": 76.14,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 323.99,
                    "currencyCode": "USD",
                    "convertedAmount": 323.99,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 43.74,
                    "currencyCode": "USD",
                    "convertedAmount": 43.74,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Room, 2 Double Beds (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 323.99,
                  "currencyCode": "USD",
                  "convertedAmount": 323.99,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 76.14,
                  "currencyCode": "USD",
                  "convertedAmount": 76.14,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 400.13,
                      "currencyCode": "USD",
                      "convertedAmount": 400.13,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Room, 2 Double Beds (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 2
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "FULL"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOVFFTQ1RRd09UUTFOVFUyT0JvRk16Y3pOalVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "2 Double Beds",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 345.97,
                  "currencyCode": "USD",
                  "convertedAmount": 345.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 81.31,
                  "currencyCode": "USD",
                  "convertedAmount": 81.31,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 345.97,
                    "currencyCode": "USD",
                    "convertedAmount": 345.97,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 46.71,
                    "currencyCode": "USD",
                    "convertedAmount": 46.71,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Room, 2 Double Beds (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 345.97,
                  "currencyCode": "USD",
                  "convertedAmount": 345.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 81.31,
                  "currencyCode": "USD",
                  "convertedAmount": 81.31,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 427.28,
                      "currencyCode": "USD",
                      "convertedAmount": 427.28,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Room, 2 Double Beds (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 2
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Living area",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "Room, 2 Double Beds (Theme Park Access)"
      },
      {
        "description": "Artist King Room with Theme Park Access ",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDVfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious double room features air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit has 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1275,
                  "currencyCode": "AED",
                  "convertedAmount": 347.13,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 299.63,
                  "currencyCode": "AED",
                  "convertedAmount": 81.58,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1275,
                    "currencyCode": "AED",
                    "convertedAmount": 347.13,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 299.63,
                    "currencyCode": "AED",
                    "convertedAmount": 81.58,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1275,
                  "currencyCode": "AED",
                  "convertedAmount": 347.13,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 299.63,
                  "currencyCode": "AED",
                  "convertedAmount": 81.58,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1275,
                      "currencyCode": "AED",
                      "convertedAmount": 347.13,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Theme Park Access ",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Theme Park Access - Accessible",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDVfMzM4MTMwMTk4XzFfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious double room features air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit has 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1355.75,
                  "currencyCode": "AED",
                  "convertedAmount": 369.12,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 318.6,
                  "currencyCode": "AED",
                  "convertedAmount": 86.74,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1355.75,
                    "currencyCode": "AED",
                    "convertedAmount": 369.12,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 318.6,
                    "currencyCode": "AED",
                    "convertedAmount": 86.74,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1355.75,
                  "currencyCode": "AED",
                  "convertedAmount": 369.12,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 318.6,
                  "currencyCode": "AED",
                  "convertedAmount": 86.74,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1355.75,
                      "currencyCode": "AED",
                      "convertedAmount": 369.12,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Theme Park Access ",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Theme Park Access - Accessible",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDVfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious double room features air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit has 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1376,
                  "currencyCode": "AED",
                  "convertedAmount": 374.63,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 323.36,
                  "currencyCode": "AED",
                  "convertedAmount": 88.04,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1376,
                    "currencyCode": "AED",
                    "convertedAmount": 374.63,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 323.36,
                    "currencyCode": "AED",
                    "convertedAmount": 88.04,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1376,
                  "currencyCode": "AED",
                  "convertedAmount": 374.63,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 323.36,
                  "currencyCode": "AED",
                  "convertedAmount": 88.04,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1376,
                      "currencyCode": "AED",
                      "convertedAmount": 374.63,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Theme Park Access ",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Theme Park Access - Accessible",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDVfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious double room features air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit has 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1436.5,
                  "currencyCode": "AED",
                  "convertedAmount": 391.1,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 337.58,
                  "currencyCode": "AED",
                  "convertedAmount": 91.91,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1436.5,
                    "currencyCode": "AED",
                    "convertedAmount": 391.1,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 337.58,
                    "currencyCode": "AED",
                    "convertedAmount": 91.91,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1436.5,
                  "currencyCode": "AED",
                  "convertedAmount": 391.1,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 337.58,
                  "currencyCode": "AED",
                  "convertedAmount": 91.91,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1436.5,
                      "currencyCode": "AED",
                      "convertedAmount": 391.1,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Theme Park Access ",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Theme Park Access - Accessible",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDVfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious double room features air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit has 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1552,
                  "currencyCode": "AED",
                  "convertedAmount": 422.55,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 364.72,
                  "currencyCode": "AED",
                  "convertedAmount": 99.3,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1552,
                    "currencyCode": "AED",
                    "convertedAmount": 422.55,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 364.72,
                    "currencyCode": "AED",
                    "convertedAmount": 99.3,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1552,
                  "currencyCode": "AED",
                  "convertedAmount": 422.55,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 364.72,
                  "currencyCode": "AED",
                  "convertedAmount": 99.3,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1552,
                      "currencyCode": "AED",
                      "convertedAmount": 422.55,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Theme Park Access ",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Theme Park Access - Accessible",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "Artist King Room with Theme Park Access - Accessible"
      },
      {
        "description": "Room, 1 King Bed, Accessible (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOellTQ1RRd09UTXdPRE0zTWhvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 347.14,
                  "currencyCode": "USD",
                  "convertedAmount": 347.14,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 81.59,
                  "currencyCode": "USD",
                  "convertedAmount": 81.59,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 347.14,
                    "currencyCode": "USD",
                    "convertedAmount": 347.14,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 46.88,
                    "currencyCode": "USD",
                    "convertedAmount": 46.88,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Room, 1 King Bed, Accessible (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 347.14,
                  "currencyCode": "USD",
                  "convertedAmount": 347.14,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 81.59,
                  "currencyCode": "USD",
                  "convertedAmount": 81.59,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 428.73,
                      "currencyCode": "USD",
                      "convertedAmount": 428.73,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Room, 1 King Bed, Accessible (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 1
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOellTQ1RRd09UUTFOVFUzT1JvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 369.12,
                  "currencyCode": "USD",
                  "convertedAmount": 369.12,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 86.74,
                  "currencyCode": "USD",
                  "convertedAmount": 86.74,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 369.12,
                    "currencyCode": "USD",
                    "convertedAmount": 369.12,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 49.83,
                    "currencyCode": "USD",
                    "convertedAmount": 49.83,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Room, 1 King Bed, Accessible (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 369.12,
                  "currencyCode": "USD",
                  "convertedAmount": 369.12,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 86.74,
                  "currencyCode": "USD",
                  "convertedAmount": 86.74,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 455.86,
                      "currencyCode": "USD",
                      "convertedAmount": 455.86,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Room, 1 King Bed, Accessible (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 1
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "Room, 1 King Bed, Accessible (Theme Park Access)"
      },
      {
        "description": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "FULL"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TWpFME1qUTBOVGdTQ1RRd09UTXdPRE0zTmhvRk16Y3pOalVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "2 Double Beds",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 382.54,
                  "currencyCode": "USD",
                  "convertedAmount": 382.54,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 89.89,
                  "currencyCode": "USD",
                  "convertedAmount": 89.89,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 382.54,
                    "currencyCode": "USD",
                    "convertedAmount": 382.54,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 51.64,
                    "currencyCode": "USD",
                    "convertedAmount": 51.64,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 382.54,
                  "currencyCode": "USD",
                  "convertedAmount": 382.54,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 89.89,
                  "currencyCode": "USD",
                  "convertedAmount": 89.89,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 472.43,
                      "currencyCode": "USD",
                      "convertedAmount": 472.43,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "POOL"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 2
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "FULL"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TWpFME1qUTBOVGdTQ1RRd09UUTFOVFU1T0JvRk16Y3pOalVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "2 Double Beds",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 404.53,
                  "currencyCode": "USD",
                  "convertedAmount": 404.53,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 95.06,
                  "currencyCode": "USD",
                  "convertedAmount": 95.06,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 404.53,
                    "currencyCode": "USD",
                    "convertedAmount": 404.53,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 54.61,
                    "currencyCode": "USD",
                    "convertedAmount": 54.61,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 404.53,
                  "currencyCode": "USD",
                  "convertedAmount": 404.53,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 95.06,
                  "currencyCode": "USD",
                  "convertedAmount": 95.06,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 499.59,
                      "currencyCode": "USD",
                      "convertedAmount": 499.59,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "POOL"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 2
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Living area",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "View from room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "View from room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)"
      },
      {
        "description": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1405.05,
                  "currencyCode": "AED",
                  "convertedAmount": 382.54,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 330.19,
                  "currencyCode": "AED",
                  "convertedAmount": 89.9,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1405.05,
                    "currencyCode": "AED",
                    "convertedAmount": 382.54,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 330.19,
                    "currencyCode": "AED",
                    "convertedAmount": 89.9,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1405.05,
                  "currencyCode": "AED",
                  "convertedAmount": 382.54,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 330.19,
                  "currencyCode": "AED",
                  "convertedAmount": 89.9,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1405.05,
                      "currencyCode": "AED",
                      "convertedAmount": 382.54,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzFfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1485.8,
                  "currencyCode": "AED",
                  "convertedAmount": 404.52,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 349.16,
                  "currencyCode": "AED",
                  "convertedAmount": 95.06,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1485.8,
                    "currencyCode": "AED",
                    "convertedAmount": 404.52,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 349.16,
                    "currencyCode": "AED",
                    "convertedAmount": 95.06,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1485.8,
                  "currencyCode": "AED",
                  "convertedAmount": 404.52,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 349.16,
                  "currencyCode": "AED",
                  "convertedAmount": 95.06,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1485.8,
                      "currencyCode": "AED",
                      "convertedAmount": 404.52,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1498.4,
                  "currencyCode": "AED",
                  "convertedAmount": 407.95,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 352.12,
                  "currencyCode": "AED",
                  "convertedAmount": 95.87,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1498.4,
                    "currencyCode": "AED",
                    "convertedAmount": 407.95,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 352.12,
                    "currencyCode": "AED",
                    "convertedAmount": 95.87,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1498.4,
                  "currencyCode": "AED",
                  "convertedAmount": 407.95,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 352.12,
                  "currencyCode": "AED",
                  "convertedAmount": 95.87,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1498.4,
                      "currencyCode": "AED",
                      "convertedAmount": 407.95,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1566.55,
                  "currencyCode": "AED",
                  "convertedAmount": 426.51,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 368.14,
                  "currencyCode": "AED",
                  "convertedAmount": 100.23,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1566.55,
                    "currencyCode": "AED",
                    "convertedAmount": 426.51,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 368.14,
                    "currencyCode": "AED",
                    "convertedAmount": 100.23,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1566.55,
                  "currencyCode": "AED",
                  "convertedAmount": 426.51,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 368.14,
                  "currencyCode": "AED",
                  "convertedAmount": 100.23,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1566.55,
                      "currencyCode": "AED",
                      "convertedAmount": 426.51,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1674.4,
                  "currencyCode": "AED",
                  "convertedAmount": 455.87,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 393.48,
                  "currencyCode": "AED",
                  "convertedAmount": 107.13,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1674.4,
                    "currencyCode": "AED",
                    "convertedAmount": 455.87,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 393.48,
                    "currencyCode": "AED",
                    "convertedAmount": 107.13,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1674.4,
                  "currencyCode": "AED",
                  "convertedAmount": 455.87,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 393.48,
                  "currencyCode": "AED",
                  "convertedAmount": 107.13,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1674.4,
                      "currencyCode": "AED",
                      "convertedAmount": 455.87,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzNfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1787.55,
                  "currencyCode": "AED",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 420.07,
                  "currencyCode": "AED",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1787.55,
                    "currencyCode": "AED",
                    "convertedAmount": 486.68,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 420.07,
                    "currencyCode": "AED",
                    "convertedAmount": 114.37,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1787.55,
                  "currencyCode": "AED",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 420.07,
                  "currencyCode": "AED",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1787.55,
                      "currencyCode": "AED",
                      "convertedAmount": 486.68,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzNfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2029.8,
                  "currencyCode": "AED",
                  "convertedAmount": 552.63,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 477,
                  "currencyCode": "AED",
                  "convertedAmount": 129.87,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2029.8,
                    "currencyCode": "AED",
                    "convertedAmount": 552.63,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 477,
                    "currencyCode": "AED",
                    "convertedAmount": 129.87,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2029.8,
                  "currencyCode": "AED",
                  "convertedAmount": 552.63,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 477,
                  "currencyCode": "AED",
                  "convertedAmount": 129.87,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2029.8,
                      "currencyCode": "AED",
                      "convertedAmount": 552.63,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDdfMzM4MTMwMTk4XzNfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious air-conditioned triple room offers a flat-screen TV with cable channels, a tea and coffee maker, a seating area, heating as well as pool views. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2210.4,
                  "currencyCode": "AED",
                  "convertedAmount": 601.8,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 519.44,
                  "currencyCode": "AED",
                  "convertedAmount": 141.42,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2210.4,
                    "currencyCode": "AED",
                    "convertedAmount": 601.8,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 519.44,
                    "currencyCode": "AED",
                    "convertedAmount": 141.42,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2210.4,
                  "currencyCode": "AED",
                  "convertedAmount": 601.8,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 519.44,
                  "currencyCode": "AED",
                  "convertedAmount": 141.42,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2210.4,
                      "currencyCode": "AED",
                      "convertedAmount": 601.8,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "Artist Double Room with Two Double Beds, Pool View, and Theme Park Access"
      },
      {
        "description": "Artist King Room with Kids Bunk Bed and Theme Park Access",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1787.55,
                  "currencyCode": "AED",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 420.07,
                  "currencyCode": "AED",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1787.55,
                    "currencyCode": "AED",
                    "convertedAmount": 486.68,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 420.07,
                    "currencyCode": "AED",
                    "convertedAmount": 114.37,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1787.55,
                  "currencyCode": "AED",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 420.07,
                  "currencyCode": "AED",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1787.55,
                      "currencyCode": "AED",
                      "convertedAmount": 486.68,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1858.4,
                  "currencyCode": "AED",
                  "convertedAmount": 505.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 436.72,
                  "currencyCode": "AED",
                  "convertedAmount": 118.9,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1858.4,
                    "currencyCode": "AED",
                    "convertedAmount": 505.97,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 436.72,
                    "currencyCode": "AED",
                    "convertedAmount": 118.9,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1858.4,
                  "currencyCode": "AED",
                  "convertedAmount": 505.97,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 436.72,
                  "currencyCode": "AED",
                  "convertedAmount": 118.9,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1858.4,
                      "currencyCode": "AED",
                      "convertedAmount": 505.97,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 1949.05,
                  "currencyCode": "AED",
                  "convertedAmount": 530.65,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 458.03,
                  "currencyCode": "AED",
                  "convertedAmount": 124.7,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 1949.05,
                    "currencyCode": "AED",
                    "convertedAmount": 530.65,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 458.03,
                    "currencyCode": "AED",
                    "convertedAmount": 124.7,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 1949.05,
                  "currencyCode": "AED",
                  "convertedAmount": 530.65,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 458.03,
                  "currencyCode": "AED",
                  "convertedAmount": 124.7,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 1949.05,
                      "currencyCode": "AED",
                      "convertedAmount": 530.65,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2034.4,
                  "currencyCode": "AED",
                  "convertedAmount": 553.88,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 478.08,
                  "currencyCode": "AED",
                  "convertedAmount": 130.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2034.4,
                    "currencyCode": "AED",
                    "convertedAmount": 553.88,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 478.08,
                    "currencyCode": "AED",
                    "convertedAmount": 130.16,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2034.4,
                  "currencyCode": "AED",
                  "convertedAmount": 553.88,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 478.08,
                  "currencyCode": "AED",
                  "convertedAmount": 130.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2034.4,
                      "currencyCode": "AED",
                      "convertedAmount": 553.88,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzNfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2170.05,
                  "currencyCode": "AED",
                  "convertedAmount": 590.82,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 509.96,
                  "currencyCode": "AED",
                  "convertedAmount": 138.84,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2170.05,
                    "currencyCode": "AED",
                    "convertedAmount": 590.82,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 509.96,
                    "currencyCode": "AED",
                    "convertedAmount": 138.84,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2170.05,
                  "currencyCode": "AED",
                  "convertedAmount": 590.82,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 509.96,
                  "currencyCode": "AED",
                  "convertedAmount": 138.84,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2170.05,
                      "currencyCode": "AED",
                      "convertedAmount": 590.82,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzNfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2412.3,
                  "currencyCode": "AED",
                  "convertedAmount": 656.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 566.89,
                  "currencyCode": "AED",
                  "convertedAmount": 154.34,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2412.3,
                    "currencyCode": "AED",
                    "convertedAmount": 656.77,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 566.89,
                    "currencyCode": "AED",
                    "convertedAmount": 154.34,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2412.3,
                  "currencyCode": "AED",
                  "convertedAmount": 656.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 566.89,
                  "currencyCode": "AED",
                  "convertedAmount": 154.34,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2412.3,
                      "currencyCode": "AED",
                      "convertedAmount": 656.77,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzRfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2552.55,
                  "currencyCode": "AED",
                  "convertedAmount": 694.96,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 599.85,
                  "currencyCode": "AED",
                  "convertedAmount": 163.31,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2552.55,
                    "currencyCode": "AED",
                    "convertedAmount": 694.96,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 599.85,
                    "currencyCode": "AED",
                    "convertedAmount": 163.31,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2552.55,
                  "currencyCode": "AED",
                  "convertedAmount": 694.96,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 599.85,
                  "currencyCode": "AED",
                  "convertedAmount": 163.31,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2552.55,
                      "currencyCode": "AED",
                      "convertedAmount": 694.96,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzNfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2570.4,
                  "currencyCode": "AED",
                  "convertedAmount": 699.82,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 604.04,
                  "currencyCode": "AED",
                  "convertedAmount": 164.46,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2570.4,
                    "currencyCode": "AED",
                    "convertedAmount": 699.82,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 604.04,
                    "currencyCode": "AED",
                    "convertedAmount": 164.46,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2570.4,
                  "currencyCode": "AED",
                  "convertedAmount": 699.82,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 604.04,
                  "currencyCode": "AED",
                  "convertedAmount": 164.46,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2570.4,
                      "currencyCode": "AED",
                      "convertedAmount": 699.82,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzRfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2875.55,
                  "currencyCode": "AED",
                  "convertedAmount": 782.9,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 675.75,
                  "currencyCode": "AED",
                  "convertedAmount": 183.98,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2875.55,
                    "currencyCode": "AED",
                    "convertedAmount": 782.9,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 675.75,
                    "currencyCode": "AED",
                    "convertedAmount": 183.98,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2875.55,
                  "currencyCode": "AED",
                  "convertedAmount": 782.9,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 675.75,
                  "currencyCode": "AED",
                  "convertedAmount": 183.98,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2875.55,
                      "currencyCode": "AED",
                      "convertedAmount": 782.9,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "DORM"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDlfMzM4MTMwMTk4XzRfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "This quadruple room is air-conditioned and features a flat-screen TV with cable channels, a tea and coffee maker and heating. The unit offers 2 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3106.4,
                  "currencyCode": "AED",
                  "convertedAmount": 845.75,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 730,
                  "currencyCode": "AED",
                  "convertedAmount": 198.75,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3106.4,
                    "currencyCode": "AED",
                    "convertedAmount": 845.75,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 730,
                    "currencyCode": "AED",
                    "convertedAmount": 198.75,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3106.4,
                  "currencyCode": "AED",
                  "convertedAmount": 845.75,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 730,
                  "currencyCode": "AED",
                  "convertedAmount": 198.75,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3106.4,
                      "currencyCode": "AED",
                      "convertedAmount": 845.75,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Artist King Room with Kids Bunk Bed and Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "Artist King Room with Kids Bunk Bed and Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "Artist King Room with Kids Bunk Bed and Theme Park Access"
      },
      {
        "description": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "UNKNOWN_BED_TYPE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TWpFNE9UQTBOVFlTQ1RRd09UTXdPRE0zTnhvRk16Z3hNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed and 1 Twin Bunk Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 486.68,
                  "currencyCode": "USD",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 114.37,
                  "currencyCode": "USD",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 486.68,
                    "currencyCode": "USD",
                    "convertedAmount": 486.68,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 65.7,
                    "currencyCode": "USD",
                    "convertedAmount": 65.7,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 486.68,
                  "currencyCode": "USD",
                  "convertedAmount": 486.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 114.37,
                  "currencyCode": "USD",
                  "convertedAmount": 114.37,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 601.05,
                      "currencyCode": "USD",
                      "convertedAmount": 601.05,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 3
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              },
              {
                "bedCount": 1,
                "bedType": "UNKNOWN_BED_TYPE"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TWpFNE9UQTBOVFlTQ1RRd09UUTFOVFl3TXhvRk16Z3hNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed and 1 Twin Bunk Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 508.67,
                  "currencyCode": "USD",
                  "convertedAmount": 508.67,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 119.54,
                  "currencyCode": "USD",
                  "convertedAmount": 119.54,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 508.67,
                    "currencyCode": "USD",
                    "convertedAmount": 508.67,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 68.67,
                    "currencyCode": "USD",
                    "convertedAmount": 68.67,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 508.67,
                  "currencyCode": "USD",
                  "convertedAmount": 508.67,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 119.54,
                  "currencyCode": "USD",
                  "convertedAmount": 119.54,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 628.21,
                      "currencyCode": "USD",
                      "convertedAmount": 628.21,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 3
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Living area",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Living area",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Living area",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "King Artist Room With Kids Bunk Bed (Theme Park Access)"
      },
      {
        "description": "Producers King Suite with Theme Park Access",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2091,
                  "currencyCode": "AED",
                  "convertedAmount": 569.29,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 491.39,
                  "currencyCode": "AED",
                  "convertedAmount": 133.79,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2091,
                    "currencyCode": "AED",
                    "convertedAmount": 569.29,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 491.39,
                    "currencyCode": "AED",
                    "convertedAmount": 133.79,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2091,
                  "currencyCode": "AED",
                  "convertedAmount": 569.29,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 491.39,
                  "currencyCode": "AED",
                  "convertedAmount": 133.79,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2091,
                      "currencyCode": "AED",
                      "convertedAmount": 569.29,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2144,
                  "currencyCode": "AED",
                  "convertedAmount": 583.72,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 503.84,
                  "currencyCode": "AED",
                  "convertedAmount": 137.18,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2144,
                    "currencyCode": "AED",
                    "convertedAmount": 583.72,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 503.84,
                    "currencyCode": "AED",
                    "convertedAmount": 137.18,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2144,
                  "currencyCode": "AED",
                  "convertedAmount": 583.72,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 503.84,
                  "currencyCode": "AED",
                  "convertedAmount": 137.18,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2144,
                      "currencyCode": "AED",
                      "convertedAmount": 583.72,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2252.5,
                  "currencyCode": "AED",
                  "convertedAmount": 613.26,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 529.34,
                  "currencyCode": "AED",
                  "convertedAmount": 144.12,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2252.5,
                    "currencyCode": "AED",
                    "convertedAmount": 613.26,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 529.34,
                    "currencyCode": "AED",
                    "convertedAmount": 144.12,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2252.5,
                  "currencyCode": "AED",
                  "convertedAmount": 613.26,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 529.34,
                  "currencyCode": "AED",
                  "convertedAmount": 144.12,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2252.5,
                      "currencyCode": "AED",
                      "convertedAmount": 613.26,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2320,
                  "currencyCode": "AED",
                  "convertedAmount": 631.64,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 545.2,
                  "currencyCode": "AED",
                  "convertedAmount": 148.44,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2320,
                    "currencyCode": "AED",
                    "convertedAmount": 631.64,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 545.2,
                    "currencyCode": "AED",
                    "convertedAmount": 148.44,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2320,
                  "currencyCode": "AED",
                  "convertedAmount": 631.64,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 545.2,
                  "currencyCode": "AED",
                  "convertedAmount": 148.44,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2320,
                      "currencyCode": "AED",
                      "convertedAmount": 631.64,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzNfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2473.5,
                  "currencyCode": "AED",
                  "convertedAmount": 673.43,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 581.27,
                  "currencyCode": "AED",
                  "convertedAmount": 158.26,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2473.5,
                    "currencyCode": "AED",
                    "convertedAmount": 673.43,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 581.27,
                    "currencyCode": "AED",
                    "convertedAmount": 158.26,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2473.5,
                  "currencyCode": "AED",
                  "convertedAmount": 673.43,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 581.27,
                  "currencyCode": "AED",
                  "convertedAmount": 158.26,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2473.5,
                      "currencyCode": "AED",
                      "convertedAmount": 673.43,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzNfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2715.75,
                  "currencyCode": "AED",
                  "convertedAmount": 739.39,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 638.2,
                  "currencyCode": "AED",
                  "convertedAmount": 173.76,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2715.75,
                    "currencyCode": "AED",
                    "convertedAmount": 739.39,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 638.2,
                    "currencyCode": "AED",
                    "convertedAmount": 173.76,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2715.75,
                  "currencyCode": "AED",
                  "convertedAmount": 739.39,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 638.2,
                  "currencyCode": "AED",
                  "convertedAmount": 173.76,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2715.75,
                      "currencyCode": "AED",
                      "convertedAmount": 739.39,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzRfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2856,
                  "currencyCode": "AED",
                  "convertedAmount": 777.57,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 671.16,
                  "currencyCode": "AED",
                  "convertedAmount": 182.73,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2856,
                    "currencyCode": "AED",
                    "convertedAmount": 777.57,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 671.16,
                    "currencyCode": "AED",
                    "convertedAmount": 182.73,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2856,
                  "currencyCode": "AED",
                  "convertedAmount": 777.57,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 671.16,
                  "currencyCode": "AED",
                  "convertedAmount": 182.73,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2856,
                      "currencyCode": "AED",
                      "convertedAmount": 777.57,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzNfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2856,
                  "currencyCode": "AED",
                  "convertedAmount": 777.57,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 671.16,
                  "currencyCode": "AED",
                  "convertedAmount": 182.73,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2856,
                    "currencyCode": "AED",
                    "convertedAmount": 777.57,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 671.16,
                    "currencyCode": "AED",
                    "convertedAmount": 182.73,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2856,
                  "currencyCode": "AED",
                  "convertedAmount": 777.57,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 671.16,
                  "currencyCode": "AED",
                  "convertedAmount": 182.73,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2856,
                      "currencyCode": "AED",
                      "convertedAmount": 777.57,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzRfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3179,
                  "currencyCode": "AED",
                  "convertedAmount": 865.51,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 747.07,
                  "currencyCode": "AED",
                  "convertedAmount": 203.4,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3179,
                    "currencyCode": "AED",
                    "convertedAmount": 865.51,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 747.07,
                    "currencyCode": "AED",
                    "convertedAmount": 203.4,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3179,
                  "currencyCode": "AED",
                  "convertedAmount": 865.51,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 747.07,
                  "currencyCode": "AED",
                  "convertedAmount": 203.4,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3179,
                      "currencyCode": "AED",
                      "convertedAmount": 865.51,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDRfMzM4MTMwMTk4XzRfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious suite provides air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 1 bed.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3392,
                  "currencyCode": "AED",
                  "convertedAmount": 923.5,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 797.12,
                  "currencyCode": "AED",
                  "convertedAmount": 217.02,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3392,
                    "currencyCode": "AED",
                    "convertedAmount": 923.5,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 797.12,
                    "currencyCode": "AED",
                    "convertedAmount": 217.02,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3392,
                  "currencyCode": "AED",
                  "convertedAmount": 923.5,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 797.12,
                  "currencyCode": "AED",
                  "convertedAmount": 217.02,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BALCONY_LANAI_TERRACE"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3392,
                      "currencyCode": "AED",
                      "convertedAmount": 923.5,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Producers King Suite with Theme Park Access",
            "roomInfo": {
              "roomType": "SUITE",
              "typeClassDescription": "Producers King Suite with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "Producers King Suite with Theme Park Access"
      },
      {
        "description": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOek1TQ1RRd09UTXdPRE0zTVJvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 569.3,
                  "currencyCode": "USD",
                  "convertedAmount": 569.3,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 133.79,
                  "currencyCode": "USD",
                  "convertedAmount": 133.79,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 569.3,
                    "currencyCode": "USD",
                    "convertedAmount": 569.3,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 76.86,
                    "currencyCode": "USD",
                    "convertedAmount": 76.86,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 569.3,
                  "currencyCode": "USD",
                  "convertedAmount": 569.3,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 133.79,
                  "currencyCode": "USD",
                  "convertedAmount": 133.79,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 703.09,
                      "currencyCode": "USD",
                      "convertedAmount": 703.09,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "PARK"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 3
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOek1TQ1RRd09UUTFOVFUzTmhvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 591.28,
                  "currencyCode": "USD",
                  "convertedAmount": 591.28,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 138.95,
                  "currencyCode": "USD",
                  "convertedAmount": 138.95,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 591.28,
                    "currencyCode": "USD",
                    "convertedAmount": 591.28,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 79.82,
                    "currencyCode": "USD",
                    "convertedAmount": 79.82,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 591.28,
                  "currencyCode": "USD",
                  "convertedAmount": 591.28,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 138.95,
                  "currencyCode": "USD",
                  "convertedAmount": 138.95,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 730.23,
                      "currencyCode": "USD",
                      "convertedAmount": 730.23,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "PARK"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 3
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "View from room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)"
      },
      {
        "description": "The WB Family Connecting Room with Theme Park Access",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzJfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2618,
                  "currencyCode": "AED",
                  "convertedAmount": 712.78,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 615.23,
                  "currencyCode": "AED",
                  "convertedAmount": 167.5,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2618,
                    "currencyCode": "AED",
                    "convertedAmount": 712.78,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 615.23,
                    "currencyCode": "AED",
                    "convertedAmount": 167.5,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2618,
                  "currencyCode": "AED",
                  "convertedAmount": 712.78,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 615.23,
                  "currencyCode": "AED",
                  "convertedAmount": 167.5,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2618,
                      "currencyCode": "AED",
                      "convertedAmount": 712.78,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzFfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2640,
                  "currencyCode": "AED",
                  "convertedAmount": 718.76,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 620.4,
                  "currencyCode": "AED",
                  "convertedAmount": 168.91,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2640,
                    "currencyCode": "AED",
                    "convertedAmount": 718.76,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 620.4,
                    "currencyCode": "AED",
                    "convertedAmount": 168.91,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2640,
                  "currencyCode": "AED",
                  "convertedAmount": 718.76,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 620.4,
                  "currencyCode": "AED",
                  "convertedAmount": 168.91,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2640,
                      "currencyCode": "AED",
                      "convertedAmount": 718.76,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 1,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzNfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2745.5,
                  "currencyCode": "AED",
                  "convertedAmount": 747.49,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 645.19,
                  "currencyCode": "AED",
                  "convertedAmount": 175.66,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2745.5,
                    "currencyCode": "AED",
                    "convertedAmount": 747.49,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 645.19,
                    "currencyCode": "AED",
                    "convertedAmount": 175.66,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2745.5,
                  "currencyCode": "AED",
                  "convertedAmount": 747.49,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 645.19,
                  "currencyCode": "AED",
                  "convertedAmount": 175.66,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2745.5,
                      "currencyCode": "AED",
                      "convertedAmount": 747.49,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": ""
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzJfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2779.5,
                  "currencyCode": "AED",
                  "convertedAmount": 756.74,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 653.18,
                  "currencyCode": "AED",
                  "convertedAmount": 177.83,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2779.5,
                    "currencyCode": "AED",
                    "convertedAmount": 756.74,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 653.18,
                    "currencyCode": "AED",
                    "convertedAmount": 177.83,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2779.5,
                  "currencyCode": "AED",
                  "convertedAmount": 756.74,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 653.18,
                  "currencyCode": "AED",
                  "convertedAmount": 177.83,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2779.5,
                      "currencyCode": "AED",
                      "convertedAmount": 756.74,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzJfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2816,
                  "currencyCode": "AED",
                  "convertedAmount": 766.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 661.76,
                  "currencyCode": "AED",
                  "convertedAmount": 180.17,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2816,
                    "currencyCode": "AED",
                    "convertedAmount": 766.68,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 661.76,
                    "currencyCode": "AED",
                    "convertedAmount": 180.17,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2816,
                  "currencyCode": "AED",
                  "convertedAmount": 766.68,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 661.76,
                  "currencyCode": "AED",
                  "convertedAmount": 180.17,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2816,
                      "currencyCode": "AED",
                      "convertedAmount": 766.68,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 2,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzRfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2873,
                  "currencyCode": "AED",
                  "convertedAmount": 782.2,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 675.16,
                  "currencyCode": "AED",
                  "convertedAmount": 183.82,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2873,
                    "currencyCode": "AED",
                    "convertedAmount": 782.2,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 675.16,
                    "currencyCode": "AED",
                    "convertedAmount": 183.82,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2873,
                  "currencyCode": "AED",
                  "convertedAmount": 782.2,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 675.16,
                  "currencyCode": "AED",
                  "convertedAmount": 183.82,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2873,
                      "currencyCode": "AED",
                      "convertedAmount": 782.2,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzNfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 2987.75,
                  "currencyCode": "AED",
                  "convertedAmount": 813.44,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 702.12,
                  "currencyCode": "AED",
                  "convertedAmount": 191.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 2987.75,
                    "currencyCode": "AED",
                    "convertedAmount": 813.44,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 702.12,
                    "currencyCode": "AED",
                    "convertedAmount": 191.16,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 2987.75,
                  "currencyCode": "AED",
                  "convertedAmount": 813.44,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 702.12,
                  "currencyCode": "AED",
                  "convertedAmount": 191.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 2987.75,
                      "currencyCode": "AED",
                      "convertedAmount": 813.44,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzVfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3023,
                  "currencyCode": "AED",
                  "convertedAmount": 823.04,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 710.41,
                  "currencyCode": "AED",
                  "convertedAmount": 193.42,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3023,
                    "currencyCode": "AED",
                    "convertedAmount": 823.04,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 710.41,
                    "currencyCode": "AED",
                    "convertedAmount": 193.42,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3023,
                  "currencyCode": "AED",
                  "convertedAmount": 823.04,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 710.41,
                  "currencyCode": "AED",
                  "convertedAmount": 193.42,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3023,
                      "currencyCode": "AED",
                      "convertedAmount": 823.04,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 5,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "promotionalOffers": [
              {
                "name": "Seasonal Deal"
              }
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzNfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3112,
                  "currencyCode": "AED",
                  "convertedAmount": 847.27,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 731.32,
                  "currencyCode": "AED",
                  "convertedAmount": 199.11,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3112,
                    "currencyCode": "AED",
                    "convertedAmount": 847.27,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 731.32,
                    "currencyCode": "AED",
                    "convertedAmount": 199.11,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3112,
                  "currencyCode": "AED",
                  "convertedAmount": 847.27,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 731.32,
                  "currencyCode": "AED",
                  "convertedAmount": 199.11,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3112,
                      "currencyCode": "AED",
                      "convertedAmount": 847.27,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 3,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzZfMzRfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3173,
                  "currencyCode": "AED",
                  "convertedAmount": 863.88,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 745.66,
                  "currencyCode": "AED",
                  "convertedAmount": 203.01,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3173,
                    "currencyCode": "AED",
                    "convertedAmount": 863.88,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 745.66,
                    "currencyCode": "AED",
                    "convertedAmount": 203.01,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3173,
                  "currencyCode": "AED",
                  "convertedAmount": 863.88,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 745.66,
                  "currencyCode": "AED",
                  "convertedAmount": 203.01,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "ROOM_ONLY"
            },
            "amenities": [
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3173,
                      "currencyCode": "AED",
                      "convertedAmount": 863.88,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 6,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzRfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3196,
                  "currencyCode": "AED",
                  "convertedAmount": 870.14,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 751.06,
                  "currencyCode": "AED",
                  "convertedAmount": 204.48,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3196,
                    "currencyCode": "AED",
                    "convertedAmount": 870.14,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 751.06,
                    "currencyCode": "AED",
                    "convertedAmount": 204.48,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3196,
                  "currencyCode": "AED",
                  "convertedAmount": 870.14,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 751.06,
                  "currencyCode": "AED",
                  "convertedAmount": 204.48,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3196,
                      "currencyCode": "AED",
                      "convertedAmount": 870.14,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzRfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3408,
                  "currencyCode": "AED",
                  "convertedAmount": 927.86,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 800.88,
                  "currencyCode": "AED",
                  "convertedAmount": 218.05,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3408,
                    "currencyCode": "AED",
                    "convertedAmount": 927.86,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 800.88,
                    "currencyCode": "AED",
                    "convertedAmount": 218.05,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3408,
                  "currencyCode": "AED",
                  "convertedAmount": 927.86,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 800.88,
                  "currencyCode": "AED",
                  "convertedAmount": 218.05,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3408,
                      "currencyCode": "AED",
                      "convertedAmount": 927.86,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 4,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzVfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3441,
                  "currencyCode": "AED",
                  "convertedAmount": 936.84,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 808.64,
                  "currencyCode": "AED",
                  "convertedAmount": 220.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3441,
                    "currencyCode": "AED",
                    "convertedAmount": 936.84,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 808.64,
                    "currencyCode": "AED",
                    "convertedAmount": 220.16,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3441,
                  "currencyCode": "AED",
                  "convertedAmount": 936.84,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 808.64,
                  "currencyCode": "AED",
                  "convertedAmount": 220.16,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3441,
                      "currencyCode": "AED",
                      "convertedAmount": 936.84,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 5,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzZfMzNfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3686,
                  "currencyCode": "AED",
                  "convertedAmount": 1003.55,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 866.21,
                  "currencyCode": "AED",
                  "convertedAmount": 235.83,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3686,
                    "currencyCode": "AED",
                    "convertedAmount": 1003.55,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 866.21,
                    "currencyCode": "AED",
                    "convertedAmount": 235.83,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3686,
                  "currencyCode": "AED",
                  "convertedAmount": 1003.55,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 866.21,
                  "currencyCode": "AED",
                  "convertedAmount": 235.83,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "BED_AND_BREAKFAST"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3686,
                      "currencyCode": "AED",
                      "convertedAmount": 1003.55,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 6,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzVfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 3778,
                  "currencyCode": "AED",
                  "convertedAmount": 1028.6,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 887.83,
                  "currencyCode": "AED",
                  "convertedAmount": 241.72,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 3778,
                    "currencyCode": "AED",
                    "convertedAmount": 1028.6,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 887.83,
                    "currencyCode": "AED",
                    "convertedAmount": 241.72,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 3778,
                  "currencyCode": "AED",
                  "convertedAmount": 1028.6,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 887.83,
                  "currencyCode": "AED",
                  "convertedAmount": 241.72,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 3778,
                      "currencyCode": "AED",
                      "convertedAmount": 1028.6,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 5,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 2,
                "bedType": "DOUBLE"
              },
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEho3ODU5MjIyMDZfMzM4MTMwMTk4XzZfMTdfMCK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwGDogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "The spacious family room offers air conditioning, a tea and coffee maker, a seating area, heating, as well as a flat-screen TV with cable channels. The unit offers 3 beds.",
            "rateInfo": {
              "rateSource": "BOOKING_COM",
              "totalRate": {
                "base": {
                  "amount": 4148,
                  "currencyCode": "AED",
                  "convertedAmount": 1129.33,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 974.78,
                  "currencyCode": "AED",
                  "convertedAmount": 265.39,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 4148,
                    "currencyCode": "AED",
                    "convertedAmount": 1129.33,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 974.78,
                    "currencyCode": "AED",
                    "convertedAmount": 265.39,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "",
              "isCvvRequired": false,
              "rateSupplier": "BOOKING_COM",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 4148,
                  "currencyCode": "AED",
                  "convertedAmount": 1129.33,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 974.78,
                  "currencyCode": "AED",
                  "convertedAmount": 265.39,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST",
                "DINNER"
              ],
              "mealType": "HALF_BOARD_MODIFIED_AMERICAN_PLAN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_DINNER"
              },
              {
                "complimentary": false,
                "type": "COFFEE_TEA_MAKER"
              },
              {
                "complimentary": false,
                "type": "INTERNET_ACCESS"
              },
              {
                "complimentary": false,
                "type": "SHOWER_ONLY"
              },
              {
                "complimentary": false,
                "type": "COLOR_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "TELEPHONE"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING"
              },
              {
                "complimentary": false,
                "type": "HAIRDRYER"
              },
              {
                "complimentary": false,
                "type": "BATHROBE"
              },
              {
                "complimentary": false,
                "type": "REFRIGERATOR"
              },
              {
                "complimentary": false,
                "type": "IRONING_BOARD"
              },
              {
                "complimentary": false,
                "type": "SITTING_AREA"
              },
              {
                "complimentary": false,
                "type": "BATHROOM_AMENITIES"
              },
              {
                "complimentary": false,
                "type": "VCR_PLAYER"
              },
              {
                "complimentary": false,
                "type": "AIR_CONDITIONING_INDIVIDUALLY_CONTROLLED_IN_ROOM"
              },
              {
                "complimentary": false,
                "type": "CABLE_TELEVISION"
              },
              {
                "complimentary": false,
                "type": "CONNECTING_ROOMS"
              },
              {
                "complimentary": false,
                "type": "WAKEUP_CALLS"
              },
              {
                "complimentary": false,
                "type": "BIDET"
              },
              {
                "complimentary": false,
                "type": "CRIBS"
              },
              {
                "complimentary": false,
                "type": "DOWN_FEATHER_PILLOWS"
              },
              {
                "complimentary": false,
                "type": "FIRE_ALARM"
              },
              {
                "complimentary": false,
                "type": "SAFE"
              },
              {
                "complimentary": false,
                "type": "SOUNDPROOFED_ROOM"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 0,
                      "currencyCode": "AED",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T19:59:59"
                    }
                  }
                },
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 4148,
                      "currencyCode": "AED",
                      "convertedAmount": 1129.33,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T20:00:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "The WB Family Connecting Room with Theme Park Access",
            "roomInfo": {
              "roomType": "ROOM",
              "typeClassDescription": "The WB Family Connecting Room with Theme Park Access",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": false,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": ""
              },
              {
                "cardCompany": "VISA",
                "description": ""
              },
              {
                "cardCompany": "MASTERCARD",
                "description": ""
              },
              {
                "cardCompany": "DINERS_CLUB",
                "description": ""
              },
              {
                "cardCompany": "JCB",
                "description": ""
              },
              {
                "cardCompany": "DISCOVER",
                "description": ""
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 6,
              "numChildren": 0
            },
            "isModifiable": false,
            "additionalDetails": [
              {
                "additionalDetailType": "IMPORTANT_INFO",
                "text": "Reservation is Inclusive of 1 Yas Island Theme Park Access per Night Stay per registered guest to either Ferrari World Abu Dhabi, Yas Waterworld, Warner Bros. World™ Abu Dhabi or SeaWorld Yas Island Abu Dhabi. Terms and Conditions Apply.\n\nGuests are required to show original photo identification and a credit card upon check-in.\n\nIn observance of the holy month of Ramadan, the hotel serves Iftar. Guests who prefer to have Iftar are welcome to make the necessary arrangements with our team.\nPlease inform  of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.\nGuests are required to show a photo ID and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nGuests under the age of 18 can only check in with a parent or official guardian."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "<h2>Elegant Accommodations</h2>\n\nThe WB Abu Dhabi, Curio Collection by Hilton in Abu Dhabi offers luxurious rooms with balconies, pool views, and modern amenities. Each room includes air-conditioning, free WiFi, and a private bathroom.\n\n<h2>Exceptional Facilities</h2>\n\nGuests can enjoy a rooftop swimming pool, spa facilities, fitness center, and a lush garden. Additional amenities include a terrace, restaurant, bar, and children's playground.\n\n<h2>Dining Experience</h2>\n\nThe modern, family-friendly restaurant serves brunch, lunch, and dinner with halal options. Breakfast includes local specialties, fresh pastries, and a variety of beverages.\n\n<h2>Prime Location</h2>\n\nLocated 6.2 mi from Zayed International Airport, the hotel is a short walk from Yas Waterworld and Yas Marina Formula 1 Circuit. Nearby attractions include Ferrari World and Sheikh Zayed Grand Mosque."
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "isFopModifiable": true
          }
        ],
        "roomGroupKey": "The WB Family Connecting Room with Theme Park Access"
      },
      {
        "description": "Family Room, Connecting Rooms (Theme Park Access)",
        "rateOptions": [
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOemtTQ1RRd09UTXdPRE0zTXhvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 712.78,
                  "currencyCode": "USD",
                  "convertedAmount": 712.78,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 167.5,
                  "currencyCode": "USD",
                  "convertedAmount": 167.5,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 712.78,
                    "currencyCode": "USD",
                    "convertedAmount": 712.78,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 96.22,
                    "currencyCode": "USD",
                    "convertedAmount": 96.22,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Family Room, Connecting Rooms (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 712.78,
                  "currencyCode": "USD",
                  "convertedAmount": 712.78,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 167.5,
                  "currencyCode": "USD",
                  "convertedAmount": 167.5,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 880.28,
                      "currencyCode": "USD",
                      "convertedAmount": 880.28,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Family Room, Connecting Rooms (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 6,
              "numChildren": 5
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          },
          {
            "bedInfos": [
              {
                "bedCount": 1,
                "bedType": "KING"
              }
            ],
            "priceValidateKey": "ChAyYTUwMTQ4ZmE4NjkyMWZjEixDZ2t6TVRVMk16a3dOemtTQ1RRd09UUTFOVFU0TmhvRk16Y3pNakVnQVE9PSK8AgomCiRhZjVlZTg1MC1kNGEwLTQzYjctYWNhMS0wMWU1MWU5NjY4ZGMSJgokZWNjYTJhYzItNjU4MS00YmQzLWFmM2UtZDAwNTU1Nzg0ZjBkIiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZipSCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZhIoCiYKJGVjYzViODM1LTgwMDEtNDMwYy05OGY4LWZlZGVjY2ViZTRjZjJuCkIKJgokZWNjNWI4MzUtODAwMS00MzBjLTk4ZjgtZmVkZWNjZWJlNGNmEhhTcG90bmFuYSBUZWNobm9sb2d5IEx0ZC4SKAomCiRlY2M1YjgzNS04MDAxLTQzMGMtOThmOC1mZWRlY2NlYmU0Y2YqEGIwZDZlZjc5Mjc2MTQwNTIwETogCgIIARIMCgoyMDI2LTA3LTA5GgwKCjIwMjYtMDctMTBCEFNQT1ROQU5BOjEwOTQ4ODVa3ARDaEJUVUU5VVRrRk9RVG94TURrME9EZzFFaUFLQWdnQkVnd0tDakl3TWpZdE1EY3RNRGthREFvS01qQXlOaTB3TnkweE1DcThBZ29tQ2lSaFpqVmxaVGcxTUMxa05HRXdMVFF6WWpjdFlXTmhNUzB3TVdVMU1XVTVOalk0WkdNU0pnb2taV05qWVRKaFl6SXROalU0TVMwMFltUXpMV0ZtTTJVdFpEQXdOVFUxTnpnMFpqQmtJaVlLSkdWall6VmlPRE0xTFRnd01ERXRORE13WXkwNU9HWTRMV1psWkdWalkyVmlaVFJqWmlwU0NpWUtKR1ZqWXpWaU9ETTFMVGd3TURFdE5ETXdZeTA1T0dZNExXWmxaR1ZqWTJWaVpUUmpaaElvQ2lZS0pHVmpZelZpT0RNMUxUZ3dNREV0TkRNd1l5MDVPR1k0TFdabFpHVmpZMlZpWlRSalpqSnVDa0lLSmdva1pXTmpOV0k0TXpVdE9EQXdNUzAwTXpCakxUazRaamd0Wm1Wa1pXTmpaV0psTkdObUVoaFRjRzkwYm1GdVlTQlVaV05vYm05c2IyZDVJRXgwWkM0U0tBb21DaVJsWTJNMVlqZ3pOUzA0TURBeExUUXpNR010T1RobU9DMW1aV1JsWTJObFltVTBZMll5RUdJd1pEWmxaamM1TWpjMk1UUXdOVEk2QWhBUk9nSVFHRUlRWWpCa05tVm1Oemt5TnpZeE5EQTFNbG9nQ2g0eU1ESTJMVEEzTFRFeFZERXdPakl4T2pRM0xqZzFNVGd6TnpZeU1WcGlBa1ZJ",
            "description": "1 King Bed",
            "rateInfo": {
              "rateSource": "EXPEDIA",
              "totalRate": {
                "base": {
                  "amount": 734.77,
                  "currencyCode": "USD",
                  "convertedAmount": 734.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 172.67,
                  "currencyCode": "USD",
                  "convertedAmount": 172.67,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              },
              "rateType": "PUBLISHED",
              "nightlyRate": [
                {
                  "base": {
                    "amount": 734.77,
                    "currencyCode": "USD",
                    "convertedAmount": 734.77,
                    "convertedCurrency": "USD"
                  },
                  "tax": {
                    "amount": 99.19,
                    "currencyCode": "USD",
                    "convertedAmount": 99.19,
                    "convertedCurrency": "USD"
                  },
                  "roomFees": [],
                  "taxBreakdown": []
                }
              ],
              "ratePlanName": "Family Room, Connecting Rooms (Theme Park Access)",
              "isCvvRequired": false,
              "rateSupplier": "EXPEDIA",
              "publishedRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "publishedNightlyRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "",
                  "convertedAmount": 0,
                  "convertedCurrency": ""
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "prepaidRate": {
                "base": {
                  "amount": 734.77,
                  "currencyCode": "USD",
                  "convertedAmount": 734.77,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 172.67,
                  "currencyCode": "USD",
                  "convertedAmount": 172.67,
                  "convertedCurrency": "USD"
                },
                "roomFees": [],
                "taxBreakdown": []
              },
              "postpaidRate": {
                "base": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "tax": {
                  "amount": 0,
                  "currencyCode": "USD",
                  "convertedAmount": 0,
                  "convertedCurrency": "USD"
                },
                "roomFees": [
                  {
                    "amount": {
                      "amount": 0,
                      "currencyCode": "USD",
                      "convertedAmount": 0,
                      "convertedCurrency": "USD"
                    },
                    "feeInclusions": [],
                    "displayFee": false,
                    "feeType": "DESTINATION_AMENITY_FEE"
                  }
                ],
                "taxBreakdown": []
              }
            },
            "meals": {
              "mealsIncluded": [
                "BREAKFAST"
              ],
              "mealType": "UNKNOWN"
            },
            "amenities": [
              {
                "complimentary": true,
                "type": "MEAL_INCLUDED_BREAKFAST"
              },
              {
                "complimentary": true,
                "type": "WIRELESS_INTERNET_CONNECTION"
              }
            ],
            "cancellationPolicy": {
              "refundable": "TRUE",
              "terms": [
                {
                  "penalty": {
                    "penaltyAmount": {
                      "amount": 907.44,
                      "currencyCode": "USD",
                      "convertedAmount": 907.44,
                      "convertedCurrency": "USD"
                    }
                  },
                  "deadline": {
                    "deadlineAbsolute": {
                      "iso8601": "2026-07-08T23:59:00"
                    }
                  }
                }
              ],
              "cancellableStatus": "CANCELLABLE_STATUS_UNSPECIFIED"
            },
            "policyInfo": {
              "id": {
                "id": "e6330ecd-f843-4fac-a04f-e3a86395cdda"
              },
              "policyType": "DEFAULT",
              "policyName": "DEFAULT",
              "ruleResultInfos": [],
              "version": 0
            },
            "guaranteeType": "GUARANTEE",
            "displayName": "Family Room, Connecting Rooms (Theme Park Access)",
            "roomInfo": {
              "roomType": "UNKNOWN_ROOM",
              "roomView": "UNKNOWN"
            },
            "isPrepaidRoom": true,
            "supportedCardTypes": [
              {
                "cardCompany": "AMEX",
                "description": "American Express"
              },
              {
                "cardCompany": "UNION_PAY",
                "description": "Union Pay"
              },
              {
                "cardCompany": "VISA",
                "description": "Visa"
              },
              {
                "cardCompany": "DISCOVER",
                "description": "Discover"
              },
              {
                "cardCompany": "JCB",
                "description": "JCB"
              },
              {
                "cardCompany": "MASTERCARD",
                "description": "Master Card"
              }
            ],
            "numRoomsRequired": 0,
            "maxOccupancy": {
              "numAdults": 6,
              "numChildren": 5
            },
            "isModifiable": true,
            "additionalDetails": [
              {
                "additionalDetailType": "CHECK_IN_CHECK_OUT_INFORMATION",
                "text": "Extra-person charges may apply and vary depending on property policy. / Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges. / Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed. / This property accepts credit cards, debit cards, and cash. / This property reserves the right to pre-authorize the guest's credit card prior to arrival.. / Cashless transactions are available. / Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit. / This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room  This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools."
              },
              {
                "additionalDetailType": "MISCELLANEOUS_INFORMATION",
                "text": "Pool access available from 8:00 AM to 11:00 PM.. / The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation. . / No pets and no service animals are allowed at this property. . / Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device. "
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands."
              },
              {
                "additionalDetailType": "ROOM_INFORMATION",
                "text": "Make yourself at home in one of the 257 air-conditioned rooms featuring minibars and espresso makers. 55-inch LED televisions with satellite programming provide entertainment, while complimentary wireless internet access keeps you connected. Bathrooms feature shower/tub combinations with rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and desks."
              },
              {
                "additionalDetailType": "PROPERTY_DESCRIPTION",
                "text": "Distances are displayed to the nearest 0.1 mile and kilometer.  Warner Bros. World Abu Dhabi - 0.3 km / 0.2 mi  Yas Waterworld - 0.5 km / 0.3 mi  Yas Mall - 0.9 km / 0.5 mi  Ferrari World - 1.4 km / 0.8 mi  Etihad Park - 1.7 km / 1.1 mi  Yas Kartzone - 2.2 km / 1.3 mi  Yas Marina Circuit - 2.3 km / 1.4 mi  Yas Beach - 3.2 km / 2 mi  Yas Public Beach - 3.8 km / 2.4 mi  Etihad Arena - 4.2 km / 2.6 mi  Yas Marina - 4.7 km / 2.9 mi  Aldar Headquarter Building - 11.1 km / 6.9 mi  Al Raha Mall - 11.5 km / 7.1 mi  Higher Colleges of Technology-Abu Dhabi Women's College - 12 km / 7.5 mi  Al Ghazal Golf Club - 13.1 km / 8.1 mi  The nearest major airport is Abu Dhabi Intl. Airport (AUH) - 22.2 km / 13.8 mi"
              },
              {
                "additionalDetailType": "AMENITY_INFORMATION",
                "text": "Free self parking"
              }
            ],
            "earnLoyaltyPoints": false,
            "rewardPointsEarned": [],
            "paymentDescription": [
              "This payment will be processed in the US"
            ],
            "isFopModifiable": true
          }
        ],
        "imageSets": [
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "Room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM",
            "imageGroup": {
              "caption": "View from room",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg"
                }
              ]
            }
          },
          {
            "category": "GUEST_ROOM_AMENITY",
            "imageGroup": {
              "caption": "Bathroom shower",
              "images": [
                {
                  "data": "",
                  "dimensions": {
                    "height": 350,
                    "width": 350
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 70,
                    "width": 70
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 200,
                    "width": 200
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg"
                },
                {
                  "data": "",
                  "dimensions": {
                    "height": 800,
                    "width": 800
                  },
                  "url": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
                }
              ]
            }
          }
        ],
        "roomGroupKey": "Family Room, Connecting Rooms (Theme Park Access)"
      }
    ],
    "bookedRooms": [],
    "occupancyDates": {
      "occupancy": [
        {
          "numAdults": 1,
          "numChildren": 0
        }
      ],
      "checkInDate": {
        "iso8601": "2026-07-09"
      },
      "checkOutDate": {
        "iso8601": "2026-07-10"
      }
    },
    "showOnlyBaseFare": true,
    "preferences": [
      {
        "preferredType": "NOT_PREFERRED",
        "blockedReason": ""
      }
    ]
  },
  "_meta": {
    "provenance": {
      "provider": "SPOTNANA",
      "sourceApi": "spotnana-hotel-v2",
      "phase": "details",
      "mode": "LIVE"
    },
    "freshness": {
      "timestamp": "2026-07-08T10:23:51.381651Z",
      "expiry": "2026-07-08T10:33:51.381651Z",
      "secondsUntilExpiry": 600
    },
    "completeness": {
      "isComplete": true,
      "missingFields": [],
      "degradedReason": null
    }
  },
  "_links": {
    "self": {
      "href": "/hotels/v1/spotnana/SPOTNANA:1094885",
      "method": "GET"
    },
    "pricing": {
      "href": "/hotels/v1/spotnana/SPOTNANA:1094885/pricing",
      "method": "GET"
    },
    "policies": {
      "href": "/hotels/v1/spotnana/SPOTNANA:1094885/policies",
      "method": "GET"
    }
  }
};
